<template>
  <component :is="pageComponent" />
</template>

<script>
import PcAttention from "@/views/pc/attention/index.vue";
import MAttention from "@/views/mobile/attention/index.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "AttentionBridge",
  computed: {
    pageComponent() {
      return isMobile() ? MAttention : PcAttention;
    },
  },
};
</script>
